var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormViewTemplate',{attrs:{"backButtonRoute":'/settings/products',"dataModel":_vm.dataModel,"pageData":_vm.pageData,"toolbarOptions":_vm.toolbarOptions,"formItems":_vm.setFormItems,"saveModel":_vm.model,"formContentReady":_vm.formContentReady}})
}
var staticRenderFns = []

export { render, staticRenderFns }